import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Testimonial } from '../../types';
import { AvatarGroup } from '../avatar-group';

interface TestimonialCardProps {
  testimonial: Testimonial;
  allTestimonials: Testimonial[];
  activeIndex: number;
  onScrollClick: (direction: 'left' | 'right') => void;
}

const SWIPE_THRESHOLD = 50;

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  testimonial,
  allTestimonials,
  activeIndex,
  onScrollClick,
}) => {
  const { t } = useTranslation();
  const touchStartX = useRef<number | null>(null);

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStartX.current === null) return;
    const delta = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(delta) >= SWIPE_THRESHOLD) {
      onScrollClick(delta > 0 ? 'right' : 'left');
    }
    touchStartX.current = null;
  };

  return (
    <div
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      className={clsx(
      'rounded-lg sm:flex-1 sm:bg-white',
      'w-full',
      'px-4 sm:px-7',
      'pt-7 sm:py-7 md:py-9'
    )}>
      {/* Quote Text */}
      <blockquote className="mb-4">
        <p className={clsx(
          'font-medium text-center text-text-primaryHeavy',
          'text-lead1 md:text-4xl'
        )}>
          "{t(testimonial.quoteKey)}"
        </p>
      </blockquote>

      {/* Bottom Section */}
      <div className="flex flex-col items-center">
        {/* Avatars */}
        <AvatarGroup testimonials={allTestimonials} activeIndex={activeIndex} />

        {/* User Info */}
        <div className={clsx(
          'flex flex-col items-center',
          'text-center'
        )}>
          <p className="text-lead1 text-text-primaryHeavy">{t(testimonial.nameKey)}</p>
          <p className={clsx(
            'font-medium text-text-primaryLight',
            'text-lead2'
          )}>{t(testimonial.yearsKey)}</p>
        </div>
      </div>
    </div>
  );
};

export { TestimonialCard };
